import {comparators} from './compare.js';
import {icon} from './icon.js';
import {title} from './title.js';
import {modal, progressbar} from './modals.js';
import {spore} from './spore.js';
import {haptic_vibrate} from './haptic.js';
import {buttonPresser} from './button.js';
import {envelopeIndex} from './modulators/envelope.js';
import {vec2, vec3} from './vec3.js';
import {rubix} from './datastructures/rubix.js';
import {listGenerators} from './datastructures/list-generators.js';
import {effects} from './fx/effects.js';
import {playback} from './playback.js';
import {groups} from './groups.js';
import {listUtils} from './datastructures/utils.js';
import {colorFunctions} from './colors.js';
import {attributes} from './attributes.js';
import {texture} from './graphics/texture.js';
import {print} from './log.js';
import {synthcontrol} from './synth.js';
import {out_switch, z_switch} from './switch.js';
import {mouseSDF} from './gl/shader.js';
import {globalReverse, loop} from './global.js';
import {gl_index} from './gl/index.js';
import {gl_material} from './gl/shader.js';
import {uniqueAppend} from './datastructures/set.js';
import {submix, mixbuttons} from './submix.js';
import {roll} from './roll.js';
import {system5} from './system5.js';
import {sampleBank} from './bank/samplebank.js';
import {tracker} from './ui/tracker.js';
import {tidal, outputNumber} from './tidal/tidal.js';
import {matrix} from './datastructures/matrix.js';
import {toggle} from './toggle.js';
import {dedupe, messageFilter, messageFilterLazy, messageSplitter} from './message.js';
import {record} from './record.js';
import {jsnapshot} from './jaki/jsnap.js';
import {dpad} from './dpad.js';
import {cirklon} from './cirklon.js';
import {patterns} from './patterns.js';
import {jrepl} from './jaki/jrepl.js';
import {macro} from './zmacro.js';
import {script} from './script.js';
import {envelope} from './envelope.js';
import {keyboard} from './keyboard.js';
import {store} from './store.js';
import {dHull, centroid} from './graphics/hull2.js';
import {startBang, loadBang} from './loadbang.js';
import {averageDistance, average} from './distance.js';
import {materials} from './graphics/materials.js';
import {convexHull, spline} from './graphics/spline.js';
import {order} from './order.js';
import {cameras} from './graphics/camera-3d.js';
import {mesh} from './graphics/mesh-3d.js';
import {float32Array} from './array.js';
import {geometry_3d} from './graphics/geometry-3d.js';
import {three} from './graphics/3d.js';
import {sceneDefinitions} from './graphics/scene.js';
import {delaunay, delaunayIndex} from './graphics/triangulation.js';
import {_triangulate, triangle, drawTriangles, drawArray, rasterTriangle, rasterTriangles, canvas, coords} from './graphics/canvas.js';
import {colors} from './graphics/color.js';
import {setInterval, setIntervalFast, metro, syncedMetro} from './metro.js';
import {planeRenderer} from './graphics/plane-renderer.js';
import {nft, erc720_tokenID} from './nft.js';
import {jtypes, jgrid} from './jaki/jgrid.js';
import {jpolygons, jhits, jclock} from './jaki/jpolygons.js';
import {polygonsToMeshes} from './graphics/polygon.js';
import {pad} from './pad.js';
import {zl} from './zl.js';
import {split} from './split.js';
import {comment} from './comment.js';
import {get, set} from './objects.js';
import {instancedSubpatch, subpatch} from './subpatch.js';
import {track} from './track.js';
import {simpleCounter, counter} from './counter.js';
import {appendList, sparseMerge, lconcat, singleSparseList, sparseList, listOsc, centerFillArray, fillArray, interleavedConcat, list_indexOf, appendEvery, prependIndex, partition, reverseList, listMax, flattenList, cList, smokeColors, smokeVertices, list, sublist, push, append, concat, nth, map, interleaf} from './datastructures/list.js';
import {varz} from './pattr.js';
import {matrixOperations} from './datastructures/matrix-operations.js';
import {jaki_objects} from './jaki/jaki.js';
import {jrules} from './jaki/jrules.js';
import {math} from './math.js';
import {indexpack, replacepak, pak, pack, packFull, unpack} from './pack.js';
import {between, nameIndex, select} from './select';
import {interface_xy, interface_multi_xy} from './xy.js';
import {record_pause, record_mix} from './mixRecord.js';

export const definitions = {
    'record.mix': record_mix,
    'record.pause': record_pause,
    spore,
    'interface.xy': interface_xy,
    'interface.multiXY': interface_multi_xy,
    indexpack,
    replacepak,
    ... colorFunctions,
    ... texture,
    ... comparators,
    concat,
    "list.indexOf": list_indexOf,
    "list.prependIndex": prependIndex,
    "list.appendEvery": appendEvery,
    fillArray,
    listOsc,
    centerFillArray,
    icon,
    interleavedConcat,
    between,
    nameIndex,
    interleaf,
    "list.reverse": reverseList,
    playback,
    ... effects,
    nth,
    "document.title": title,
    uniqueAppend,
    modal,
    progressbar,
    centroid,
    'erc720.tokenID': erc720_tokenID,
    "list.partition": partition,
    messageSplitter,
    "three.planeRenderer" : planeRenderer,
    messageFilter,
    "haptic.vibrate": haptic_vibrate,
    matrix,
    globalReverse,
    loop,
    push,
    "gl.material": gl_material,
    vec3,
    vec2,
    buttonPresser,
    groups,
    ... listGenerators,
    select,
    ... listUtils,
    ... gl_index,
    attributes,
    ... record,
    varz,
    toggle,
    sparseList,
    singleSparseList,
    smokeColors,
    submix,
    mixbuttons,
    loadBang,
    startBang,
    average,
    roll,
    macro,
    mouseSDF,
    triangulate: _triangulate,
    print,
    averageDistance,
    dpad,
    system5,
    sampleBank,
    drawTriangles,
    jrepl,
    cirklon,
    patterns,
    store,
    drawArray,
    polygonsToMeshes,
    triangle,
    synthcontrol,
    "switch": z_switch,
    "outSwitch": out_switch,
    dedupe,
    messageFilterLazy,
    jpolygons,
    jhits,
    jclock,
    "ztracker": tracker,
    coords,
    rasterTriangle,
    tidal,
    outputNumber, 
    rasterTriangles,
    metro,
    syncedMetro,
    setInterval,
    setIntervalFast,
    lconcat,
    jsnapshot,
    counter,
    simpleCounter,
    ... envelope,
    canvas,
    ... three,
    ... geometry_3d,
    ... order,
    ... sceneDefinitions,
    ... materials,
    ... keyboard,
    ... mesh,
    ...cameras,
    script,
    float32Array,
    map,
    spline,
    convexHull,
    smokeVertices,
    flattenList,
    cList,
    listMax,
    pack,
    packFull,
    pak,
    nft,
    append,
    appendList,
    pad,
    unpack,
    subpatch,
    instancedSubpatch,
    split,
    jgrid,
    jtypes,
    track,
    comment,
    delaunay,
    delaunayIndex,
    dHull,
    zl,
    get, set,
    ... colors,
    ... math,
    ... jaki_objects,
    list,
    sublist,
    ... jrules,
    ... envelopeIndex,
    sparseMerge,
    ... matrixOperations,
    ... rubix
};
